module.exports = __webpack_public_path__ + "img/HIDE.c2ebdae0.svg";